import { Controller } from "@hotwired/stimulus";

export default class RecordingFilterController extends Controller {
  static targets = ["form"];

  declare readonly formTarget: HTMLFormElement;
  declare readonly hasFormTarget: boolean;

  private debounceTimer: number | null = null;
  private readonly DEBOUNCE_DELAY = 300;

  disconnect(): void {
    if (this.debounceTimer != null) {
      window.clearTimeout(this.debounceTimer);
    }
  }

  submit(): void {
    if (!this.hasFormTarget) return;
    this.formTarget.requestSubmit();
  }

  debounceSubmit(): void {
    if (this.debounceTimer != null) window.clearTimeout(this.debounceTimer);
    this.debounceTimer = window.setTimeout(() => this.submit(), this.DEBOUNCE_DELAY);
  }
}
